import {
	BaseQueryFn,
	createApi,
	FetchArgs,
	fetchBaseQuery,
	FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

import { appConfig } from '@/config'

import { requestQueue } from './requestQueue'

const rawBaseQuery = fetchBaseQuery({
	baseUrl: appConfig.apiUrl,
	prepareHeaders: (headers) => {
		const tokenFromStorage = localStorage.getItem('AUTH_TOKEN')
		const parsedToken = JSON.parse(tokenFromStorage as string).token
		headers.set('X-TenantId', appConfig.realm)
		if (parsedToken) {
			headers.set('authorization', `Bearer ${parsedToken}`)
		}
		return headers
	},
})

const dynamicBaseQuery: BaseQueryFn<
	string | FetchArgs,
	unknown,
	FetchBaseQueryError
> = async (args, api, extraOptions) => {
	// Queue the request to limit concurrent API calls (default: 4)
	return requestQueue.enqueue(() => rawBaseQuery(args, api, extraOptions))
}

export const emptySplitApiV2 = createApi({
	baseQuery: dynamicBaseQuery,
	endpoints: () => ({}),
	reducerPath: 'apiV2',
})
